
import * as React from 'react';
import * as moment from 'moment';
import * as queryString from 'query-string';
const DatePicker = require('react-mobile-datepicker');
const Toast = require('react-toast-mobile');
import config from '@/server/config';
import request from '@/server/request';
import store from '@/redux/index';
import { types } from '@/redux/ui/address';

export default class AuthEnterpriseStep1 extends React.Component<any, any> {
    public constructor(props: any) {
        super(props);
        const query = queryString.parse(this.props.location.search);
        this.state = {
            userId: '', // 用户id
            authType: query.authtype ? `${query.authtype}` : 0,
            init: query.init ? `${query.init}` : 0,
            company: '', // 公司名称
            licenceCreditCode: '', // 税号
            licenseNumber: '', // 证件编号
            companyType: '', // 公司类型
            establishTime: '', // 成立时间
            establishTimeOpen: false, // 是否显示成立时间面板
            currency: '人民币', // 币种
            registeredCapital: '', // 注册资金
            companyLegalPerson: '', // 公司法人
            companyLegalPersonIdCard: '', // 法人身份证
            actualController: '', // 实际控制人
            actualControllerIdCard: '', // 实际控制人身份证
            licenceExptimeFlag: '是', // 营业期限类型
            licenceExptime: '', // 营业期限
            licenceOpen: false, // 是否显示营业期限面板
            addressInfo: {
                city: {},
                district: {},
                province: {}
            }, // 住所
            addressDetail: '' // 住所详细地址
        }
    }
    public componentDidMount() {
        // 是否为重新认证
        if(this.state.authType === '1' || this.state.init === '1') {
            this.getData();
        } else {
            // 获取用户id，用于判断是否切换用户
            this.getUserInfo();
        }
        (document as any).documentElement.addEventListener("focusout",function(){
            (document as any).documentElement.scrollTop = 0;
            window.scrollTo(0,0);
         });
    }

    public render() {
        const state = this.state;
        return (
            <div>
                <p className="company-title">工商信息</p>
                <ul className="company">
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>公司名称</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入公司名称" value={state.company} onChange={e => this.inputAction('company', e)}/>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>税&emsp;&emsp;号</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入税号" value={state.licenceCreditCode} onChange={e => this.inputAction('licenceCreditCode', e)}/>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>&nbsp;</b>
                            <p>证件编号</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入证件编号" value={state.licenseNumber} onChange={e => this.inputAction('licenseNumber', e)}/>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>公司类型</p>
                        </div>
                        <div className="Location">
                        <input type="text" className="textmarket" placeholder="请输入公司类型" value={state.companyType} onChange={e => this.inputAction('companyType', e)}/>
                        </div>
                    </li>
                    <li onClick={() => this.openDatePanel(0)}>
                        <div className="company-tit">
                            <b>*</b>
                            <p>成立时间</p>
                        </div>
                        <span className="textmarket">{state.establishTime === '' ? '请选择成立时间' : moment(state.establishTime).format('YYYY-MM-DD')}</span>
                    </li>
                    <li className="picker-btn">
                        <select value={state.currency} onChange={(e: any) => this.pickerSelectAction(e)}>
                            <option value="人民币">人民币</option>
                            <option value="美元">美元</option>
                            <option value="港币">港币</option>
                            <option value="澳门币">澳门币</option>
                            <option value="日元">日元</option>
                            <option value="韩元">韩元</option>
                            <option value="欧元">欧元</option>
                        </select>
                        <div className="company-tit"><b>*</b><p>注册资本类型</p></div>
                        <div className="camera">
                            <div>
                                <span>{state.currency}</span>
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>注册资本（万元）</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入注册资本" value={state.registeredCapital} onChange={e => this.inputAction('registeredCapital', e)}/>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>公司法人</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入公司法人" value={state.companyLegalPerson} onChange={e => this.inputAction('companyLegalPerson', e)}/>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>&nbsp;</b>
                            <p>法人身份证</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入法人身份证" value={state.companyLegalPersonIdCard} onChange={e => this.inputAction('companyLegalPersonIdCard', e)}/>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>&nbsp;</b>
                            <p>实际控制人</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入实际控制人" value={state.actualController} onChange={e => this.inputAction('actualController', e)}/>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>&nbsp;</b>
                            <p>实际控制人身份证</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入实际控制人身份证" value={state.actualControllerIdCard} onChange={e => this.inputAction('actualControllerIdCard', e)}/>
                    </li>
                    <li className="picker-btn">
                        <select value={state.licenceExptimeFlag} onChange={(e: any) => this.licenceExptimePickerAction(e)}>
                            <option value="是">是</option>
                            <option value="否">否</option>
                        </select>
                        <div className="company-tit"><b>*</b><p>是否长期营业</p></div>
                        <div className="camera">
                            <div>
                                <span>{state.licenceExptimeFlag}</span>
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                            </div>
                        </div>
                    </li>
                    {
                        state.licenceExptimeFlag === '否' ? 
                        <li onClick={() => this.openDatePanel(1)}>
                            <div className="company-tit">
                                <b>*</b>
                                <p>营业期限</p>
                            </div>
                            <div className="Location">
                                <div>{state.licenceExptime === '' ? '请选择营业期限' : moment(state.licenceExptime).format('YYYY-MM-DD')}</div>
                            </div>
                        </li>
                        : null
                    }
                    <li onClick={() => this.openAddressPanel()}>
                        <div className="company-tit">
                            <b>*</b>
                            <p>住所</p>
                        </div>
                        <div className="camera">
                            <div>
                                <span>{state.addressInfo.province.name ? (state.addressInfo.province.name + ' ' + state.addressInfo.city.name + ' ' + state.addressInfo.district.name) : '请选择住所'}</span>
                                <img src={require('../../../assets/images/choose.png')} className="chooseImg" />
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="company-tit">
                            <b>*</b>
                            <p>住所详细地址</p>
                        </div>
                        <input type="text" className="textmarket" placeholder="请输入住所详细地址" value={state.addressDetail} onChange={e => this.inputAction('addressDetail', e)}/>
                    </li>
                </ul>
                <button className="personal-btn" disabled={!this.validatyForm()} onClick={() => this.nextAction()}>下一步</button>
                <DatePicker
                    customHeader='请选择时间'
					value={this.state.establishTime ? new Date(this.state.establishTime) : new Date()}
                    isOpen={this.state.establishTimeOpen}
					onSelect={(e: any) => this.dateSelect(0, e)}
					onCancel={() => this.dateCancel()} />
                <DatePicker
                    customHeader='请选择时间'
					value={this.state.licenceExptime ? new Date(this.state.licenceExptime) : new Date()}
                    isOpen={this.state.licenceOpen}
					onSelect={(e: any) => this.dateSelect(1, e)}
					onCancel={() => this.dateCancel()} />
            </div>
        )
    }
    // 获取数据
    private async getData() {
        const r = await request({
            url: `${config.API}member/company/info`
        });
        if(r.code === 1) {
            const obj = r.obj.companyInfo;
            if(!obj) return;
            this.setState({
                company: obj.company,
                licenceCreditCode: obj.licenceCreditCode,
                licenseNumber: obj.licenseNumber || '',
                companyType: obj.companyType,
                establishTime: new Date(obj.establishTime).getTime(),
                currency: obj.currency,
                registeredCapital: obj.registeredCapital,
                companyLegalPerson: obj.companyLegalPerson,
                companyLegalPersonIdCard: obj.companyLegalPersonIdCard || '',
                actualController: obj.actualController || '',
                actualControllerIdCard: obj.actualControllerIdCard || '',
                licenceExptimeFlag: obj.licenceExptimeFlag === 0 ? '是' : '否',
                licenceExptime: new Date(obj.licenceExptime).getTime(),
                addressInfo: {
                    city: {
                        code: obj.licenceCityCode,
                        name: obj.licenceCityName
                    },
                    district: {
                        code: obj.licenceCountyCode,
                        name: obj.licenceCountyName
                    },
                    province: {
                        code: obj.licenceProvinceCode,
                        name: obj.licenceProvinceName
                    }
                },
                addressDetail: obj.licenceDetailAddress
            });
            // 初始化地址
            if(store.getState().uiAddressReducers.listCity.length === 0) {
                store.dispatch({
                    type: types.GET_ADDRESS_START,
                    data: {
                        pCode: obj.licenceProvinceCode,
                        rating: 1,
                        copy: true
                    }
                });
                store.dispatch({
                    type: types.GET_ADDRESS_START,
                    data: {
                        pCode: obj.licenceCityCode,
                        rating: 2,
                        copy: true
                    }
                });
            }
        }
    }
    /**
     * 打开选择时间面板
     * @param type 0:成立时间 1:营业过期时间
     */
    private openDatePanel(type: number) {
        this.setState(type === 0 ? {establishTimeOpen: true} : {licenceOpen: true});
        window.scrollTo(0, 0);
        document.body.style.overflow = 'hidden';
    }
    /**
     * 时间选择确认
     * @param type 0:成立时间 1:营业过期时间
     * @param e 时间选择结果
     */
    private dateSelect(type: number, e: any) {
        this.setState(type === 0 ? {establishTime: new Date(e).getTime()} : {licenceExptime: new Date(e).getTime()});
        this.dateHide();
    }
    // 时间选择取消
    private dateCancel() {
        this.dateHide();
    }
    // 隐藏时间面板处理
    private dateHide() {
        this.setState({establishTimeOpen: false, licenceOpen: false});
        document.body.style.overflow = '';
    }
    // 打开地址面板
    private openAddressPanel() {
        const that = this;
        store.dispatch({
            type: types.ADDRESS_SHOW,
            showData: {
                init: that.state.addressInfo,
                onConfirm(r: any) {
                    that.setState({addressInfo: r});
                }
            }
        });
    }
    /**
     * 输入处理
     * @param stateName [state对应的状态名称]
     * @parma e [输入事件]
     */
    private inputAction(stateName: string, e: any) {
        let state = {...this.state};
        state[stateName] = e.target.value
        this.setState({...state});
    }
    /**
     * 选择币种
     * @parma e [输入事件]
     */
    private pickerSelectAction(e: any) {
        if(this.state.currency === e.currentTarget.value) {
            return;
        }
        this.setState({currency: e.currentTarget.value});
    }
    /**
     * 选择营业类型
     * @parma e [输入事件]
     */
    private licenceExptimePickerAction(e: any) {
        if(this.state.licenceExptimeFlag === e.currentTarget.value) {
            return;
        }
        this.setState({licenceExptimeFlag: e.currentTarget.value});
    }
    // 验证表单
    private validatyForm(): boolean {
        const state = this.state;
        return state.company !== '' && state.licenceCreditCode !== '' && 
        state.companyType !== '' && state.establishTime !== '' && state.registeredCapital !== '' && !isNaN(state.registeredCapital)
        && state.registeredCapital > 0 && state.companyLegalPerson !== '' && (state.licenceExptimeFlag === '否' ? state.licenceExptime !== '' : true) 
        && state.addressInfo.province.code && state.addressDetail !== '';
    }
    // 下一步
    private nextAction() {
        const state = this.state;
        if(state.company === '') {
            return Toast.T.notify('请填写公司名称');
        } else if(state.licenceCreditCode === '') {
            return Toast.T.notify('请填写税号');
        } else if(state.companyType === '') {
            return Toast.T.notify('请填写公司类型');
        } else if(state.establishTime === '') {
            return Toast.T.notify('请选择成立时间');
        } else if(state.registeredCapital === '') {
            return Toast.T.notify('请填写注册资金');
        } else if(isNaN(state.registeredCapital) || state.registeredCapital <= 0) {
            return Toast.T.notify('注册资金只能为大于0的数值');
        } else if(state.companyLegalPerson === '') {
            return Toast.T.notify('请填写公司法人');
        } else if(state.licenceExptimeFlag === '否' && state.licenceExptime === '') {
            return Toast.T.notify('请填写营业期限');
        } else if(!state.addressInfo.province.code) {
            return Toast.T.notify('请选择住所省市区');
        } else if(state.addressDetail === '') {
            return Toast.T.notify('请填写住所详细地址')
        }
        // 先把数据保存到本地，防止退出页面下次进来需要重新填写
        const string = JSON.stringify(this.state);
        const storage = (window as any).localStorage;

        // 如果是重新认证，先把数据保存到本地，方便统一提交
        if(this.state.authType === '1') {
            storage.setItem('enterpriseStepTemp1', string);
            this.props.history.push('/authentication/step2?authtype=1');
        } else if(this.state.init === '1') {
            storage.setItem('enterpriseStep1', string);
            this.props.history.push('/authentication/step2?init=1');
        }
        // 否则，把数据保存到本地，下次重新打开默认显示数据
        else {
            storage.setItem('enterpriseStep1', string);
            this.props.history.push('/authentication/step2');
        }
        
    }
    private async getUserInfo() {
        const r = await request({
            url: `${config.WAPAPI}safety/account/get`
        });
        // 查看本地是否已经存储数据
        const storage = (window as any).localStorage;
        const storageData = storage.getItem('enterpriseStep1');
        this.setState({userId: r.obj.id});
        if(!storageData) return;
        const storageDataObj = JSON.parse(storageData);
        const localUserId = storageData ? storageDataObj.userId : null;
        // 如果之前没有用户填写或者有并且市同一用户
        if(!localUserId || r.obj.id == localUserId) { 
            this.setState({...storageDataObj});
            // 初始化地址
            if(store.getState().uiAddressReducers.listCity.length === 0) {
                store.dispatch({
                    type: types.GET_ADDRESS_START,
                    data: {
                        pCode: storageDataObj.addressInfo.province.code,
                        rating: 1,
                        copy: true
                    }
                });
                store.dispatch({
                    type: types.GET_ADDRESS_START,
                    data: {
                        pCode: storageDataObj.addressInfo.city.code,
                        rating: 2,
                        copy: true
                    }
                });
            }
        }
    }
}